module.exports = __webpack_public_path__ + "img/nigeria.31dc2b69.svg";